import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'icon-layers-blue',
  templateUrl: './layers-blue.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayersBlueComponent {}
